import React, { FC } from 'react';
import PollEntity from '../../../store/polls-store/poll-entity';
import MoveHandleIcon from '../../shared/move-handle-icon/move-handle-icon';
import { DEFAULT_STREAM_ADJUSTMENT, PollsTabsOnMobile, PollsViewStatuses } from '../../../constans/polls-constants';
import HideForPresenter from '../shared/hide-for-presenter';
import OpenCloseButton from '../shared/open-close-button';
import { observer } from 'mobx-react';
import PollStatus from '../shared/poll-status/poll-status';
import classNames from 'classnames';
import ClosingProgress from '../shared/closing-progress';
import ElipsisMenuWrapper from '../shared/elipsis-menu-wrapper';
import ResultSlideButton from '../shared/result-slide-button';

interface IProps {
  poll: PollEntity;
  isSelected: boolean;
  isEllipsisMenuOpened: boolean;
  setShouldShowEllipsisMenu: (value: boolean) => void;
  setShouldShowDeleteModal: (value: boolean) => void;
  setShouldShowAddResultsSlideModal: (value: boolean) => void;
  setShouldShowResetModal: (value: boolean) => void;
  toggleManagePollModal: () => void;
  changePollStatus: (poll: PollEntity, customStatus?: PollsViewStatuses) => Promise<void>;
  setActiveMobileTab: (tab: PollsTabsOnMobile) => void;
  isMobile: boolean;
  setIsOnePollOpened: (value: boolean) => void;
  isOnePollOpened: boolean;
}

const Poll: FC<IProps> = ({
  poll,
  isSelected,
  isEllipsisMenuOpened,
  setShouldShowEllipsisMenu,
  setShouldShowDeleteModal,
  setShouldShowResetModal,
  toggleManagePollModal,
  changePollStatus,
  setActiveMobileTab,
  isMobile,
  setIsOnePollOpened,
  isOnePollOpened,
  setShouldShowAddResultsSlideModal,
}) => {
  const pollItemClassName = `poll-item ${isSelected ? 'selected' : ''}`;
  const { status, type } = poll;
  const shouldShowOpenCloseBtn = status !== PollsViewStatuses.COMPLETED && status !== PollsViewStatuses.RESETED;
  const shouldShowResultSlideBtn = status === PollsViewStatuses.COMPLETED && !poll.shouldShowClosingProgress;

  const changeStatusHandler = (): void => {
    changePollStatus(poll);
  };

  const handleFinishClosing = (): void => {
    poll.hideClosingProgress();
    setIsOnePollOpened(false);
  };

  return (
    <div className={pollItemClassName}>
      <MoveHandleIcon/>
      <div className='poll-item-header'>
        <HideForPresenter hideForPresenter={poll.hideForPresenter}/>
        <ElipsisMenuWrapper
          poll={poll}
          isEllipsisMenuOpened={isEllipsisMenuOpened && isSelected}
          setShouldShowEllipsisMenu={setShouldShowEllipsisMenu}
          setShouldShowDeleteModal={setShouldShowDeleteModal}
          setShouldShowResetModal={setShouldShowResetModal}
          toggleManagePollModal={toggleManagePollModal}
          setActiveMobileTab={setActiveMobileTab}
          changePollStatus={changePollStatus}
          isMobile={isMobile}
          isOnePollOpened={isOnePollOpened}
        />

      </div>
      <p className='poll-item-question'>{poll.value}</p>
      <span className='poll-item-type'>{type}</span>
      <div className='poll-item-info'>
        <div
          className={classNames('votes-status-container',
            {
              'row-direction': status === PollsViewStatuses.COMPLETED && !poll.shouldShowClosingProgress && !shouldShowResultSlideBtn,
              'content-start': status === PollsViewStatuses.NOT_STARTED,
              'closing': poll.shouldShowClosingProgress,
              'column-direction': shouldShowResultSlideBtn
            })}
        >
          {poll.shouldShowClosingProgress
            ? <ClosingProgress delay={DEFAULT_STREAM_ADJUSTMENT} timestamp={poll.pollStatusTimestamp} handleFinishClosing={handleFinishClosing}/>
            : <PollStatus status={status} additionalClassName='poll-item-status'/>
          }
          {status !== PollsViewStatuses.NOT_STARTED && <span className='poll-item-votes'>{poll.countVotes} Votes</span>}
        </div>
        {shouldShowOpenCloseBtn && <OpenCloseButton onClick={changeStatusHandler} status={status}/>}
        {shouldShowResultSlideBtn && (
          <ResultSlideButton
            openConfirmationModal={setShouldShowAddResultsSlideModal}
            showButton={!poll.result_slide_added}
            isLoading={poll.shouldShowGenerating}
          />
        )}
      </div>
    </div>
  );
};

export default observer(Poll);
